import React from 'react';
import {curry} from 'ramda';

import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import Divider from '@material-ui/core/Divider';
import Popover from '@material-ui/core/Popover';
import {ButtonBase} from '@material-ui/core';

import {JiraIssue} from './JiraTypes';
import './JiraMenu.scss';
import IssueCreateDialogContainer from '../JiraIssueCreate/JiraIssueCreateDialogConnected';

interface JiraMenuProps {
    open: boolean;
    onClose: () => void;
    anchorEl: HTMLButtonElement | null;
    issues: JiraIssue[];
    dialogIsOpen: boolean;
    handleDialogOpen: () => void;
    handleDialogClose: () => void;
    title?: string;
    priority: number;
    contentPartner: string;
    labPartner: string;
    id: number;
}

export default function JiraMenu(props: JiraMenuProps) {
    const {
        open,
        onClose,
        anchorEl,
        issues,
        dialogIsOpen,
        handleDialogOpen,
        handleDialogClose,
        title,
        priority,
        contentPartner,
        labPartner,
        id,
    } = props;
    
    return (
        <Popover
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={open}
            onClose={onClose}
            anchorEl={anchorEl}
        >
            <div className="popover">
                <div
                    className="popover__new-issue"
                >
                    <ButtonBase
                        className="new-issue-button"
                        onClick={handleDialogOpen}
                        disableRipple
                    >
                        New Jira issue
                    </ButtonBase>
                </div>
                <IssueCreateDialogContainer
                    dialogIsOpen={dialogIsOpen}
                    handleDialogClose={handleDialogClose}
                    title={title}
                    priority={priority}
                    contentPartner={contentPartner}
                    labPartner={labPartner}
                    id={id}
                />
                <Divider className="popover__divider" />
                {issues.map(mapIssues)}
            </div>
        </Popover>
    );
}

export const mapIssues = curry((issue: JiraIssue) => {
    const {
        issueUrl,
        issueSummary,
    } = issue;
    
    return (
        <div
            className="popover__issue-container"
            key={issueUrl}
        >
            <div
                className="popover__issue-summary"
            >
                {issueSummary}
            </div>
            <div
                className="popover__issue-link"
            >
                <a
                    target="_blank"
                    href={issueUrl}
                    rel="noopener noreferrer"
                >
                    <OpenInNewIcon />
                </a>
            </div>
        </div>
    );
});

JiraMenu.defaultProps = {
    title: '',
};
